import { Connection } from "@solana/web3.js";
import {RPC_URL} from "../configs/config";

export const connection = new Connection(RPC_URL, "confirmed");